import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router';

import { Center, Spinner, useToast } from '@chakra-ui/react';

import { ADMIN, TEACHER } from '../constants';
import { useAuth } from '../context/useAuth';
import Layout from '../components/Dashboard/layout';

/**
 * AdminRoute - Route guard that allows both organization admins (TEACHER role)
 * and superadmins (ADMIN role) to access admin pages
 */
const AdminRoute = () => {
  const { isAuthenticated, role, loading } = useAuth();
  const toast = useToast();
  const [hasRedirected, setHasRedirected] = useState<boolean>(false);

  // fetch organizationCode from localStorage
  const organizationCode = localStorage.getItem('organizationCode');

  useEffect(() => {
    if (
      isAuthenticated &&
      role !== TEACHER &&
      role !== ADMIN &&
      !hasRedirected
    ) {
      toast({
        position: 'top',
        title: 'アクセス権限がない',
        description: 'ページを表示する権限がありません。',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      setHasRedirected(true);
    }
  }, [isAuthenticated, role, hasRedirected, toast]);

  if (loading) {
    return (
      <Center height="100vh">
        <Spinner size="xl" color="#fca43b" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    const redirectRoute = `/login?organizationCode=${organizationCode}`;
    return <Navigate to={redirectRoute} replace />;
  }

  if (role !== TEACHER && role !== ADMIN) {
    return <Navigate to="/top" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default AdminRoute;
